
import './App.css';
import React from 'react';
import Home from './home';
import About from './about';
// import Contact from './contact';
import Error from './error';
import Portfolio from './Portfolio';
import Aboutm from "./mobiledevice/about";
 import Bodym from "./mobiledevice/body";
import { Route,  BrowserRouter, Routes} from 'react-router-dom';
function App() {


  if(window.innerWidth<=450){
    return (
      <>
      <BrowserRouter>
     <Routes>
    <Route  exact path="/" element={<Bodym/>}/>
    <Route exact path="about" element={<Aboutm/>} />
     {/* <Route exact path="portfolio" element={<Portfolio/>}/>  */}
    <Route  path='*' element={<Error/>}/> 
   
    </Routes> 
      </BrowserRouter> 
     
      </>
      );

  }else{
    return (
      <div className="App">
   <BrowserRouter>
   <Routes>
  <Route  exact path="/" element={<Home/>}/>
  <Route exact path="About" element={<About/>} />
  <Route exact path="portfolio" element={<Portfolio/>}/>
  <Route  path='*' element={<Error/>}/>
  </Routes>
   </BrowserRouter>
      </div>)
  }
 
  
}

export default App;
